<div class="modal-header">
    <h4 class="modal-title">Ingrese información faltante</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <p>Por favor complete la siguiente información pendiente relacionado a su <b>empresa</b>:</p>
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12 col-sm-6">
                <label for="nombre">Nombre</label>
                <input type="text" class="form-control" id="nombre" formControlName="nombre"
                    [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
                <div class="mb-4" *ngIf="!form.controls['nombre'].errors || !form.controls['nombre'].touched">
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <label for="rut">{{labelDocumentoIdentidad}} Empresa</label>
                <input type="text" class="form-control" id="rut" formControlName="rut"
                    [ngClass]="{'is-invalid': form.controls['rut'].errors && form.controls['rut'].touched}"
                    [mask]="maskDocumentoIdentidad">
                <div class="invalid-feedback"
                    *ngIf="form.controls['rut'].errors?.['required'] || form.controls['rut'].errors?.['mask']">
                    Debe ingresar un valor en el campo
                </div>
                <div class="invalid-feedback" *ngIf="form.controls['rut'].errors?.['rutInvalido']">
                    El {{labelDocumentoIdentidad}} de empresa ingresado no es válido.
                </div>
                <div class="mb-4" *ngIf="!form.controls['rut'].errors || !form.controls['rut'].touched">
                </div>
            </div>

            <div class="col-12">
                <label for="razon_social">Razón Social</label>
                <input type="text" class="form-control" id="razon_social" formControlName="razon_social"
                    [ngClass]="{'is-invalid': form.controls['razon_social'].errors && form.controls['razon_social'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
                <div class="mb-4"
                    *ngIf="!form.controls['razon_social'].errors || !form.controls['razon_social'].touched">
                </div>
            </div>
        </div>

        <div class="mb-3">
            <label for="email">Correo Electrónico</label>
            <input type="text" class="form-control" id="email" formControlName="email"
                [ngClass]="{'is-invalid': form.controls['email'].errors && form.controls['email'].touched}">
            <div class="invalid-feedback">
                Debe ingresar un correo electrónico válido
            </div>
            <div class="mb-4" *ngIf="!form.controls['email'].errors || !form.controls['email'].touched">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()"><i class="fas fa-pen me-2"></i>Guardar
        Información</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Más tarde</button>
</div>